"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDealRequestToJSON = exports.CreateDealRequestFromJSONTyped = exports.CreateDealRequestFromJSON = exports.instanceOfCreateDealRequest = void 0;
var runtime_1 = require("../runtime");
var DealAdFormats_1 = require("./DealAdFormats");
var DealPlacements_1 = require("./DealPlacements");
var DealType_1 = require("./DealType");
var DspPartner_1 = require("./DspPartner");
var DspProvider_1 = require("./DspProvider");
var FrequencyCap_1 = require("./FrequencyCap");
var Targets_1 = require("./Targets");
var VideoDeliveryFormat_1 = require("./VideoDeliveryFormat");
/**
 * Check if a given object implements the CreateDealRequest interface.
 */
function instanceOfCreateDealRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "seatId" in value;
    isInstance = isInstance && "salesforceDealId" in value;
    isInstance = isInstance && "dsp" in value;
    isInstance = isInstance && "adFormats" in value;
    isInstance = isInstance && "placements" in value;
    isInstance = isInstance && "priceFloorMicroAmount" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "targets" in value;
    isInstance = isInstance && "startTime" in value;
    isInstance = isInstance && "endTime" in value;
    return isInstance;
}
exports.instanceOfCreateDealRequest = instanceOfCreateDealRequest;
function CreateDealRequestFromJSON(json) {
    return CreateDealRequestFromJSONTyped(json, false);
}
exports.CreateDealRequestFromJSON = CreateDealRequestFromJSON;
function CreateDealRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'seatId': json['seat_id'],
        'salesforceDealId': json['salesforce_deal_id'],
        'salesforceLineItemId': !(0, runtime_1.exists)(json, 'salesforce_line_item_id') ? undefined : json['salesforce_line_item_id'],
        'salesforceOrderId': !(0, runtime_1.exists)(json, 'salesforce_order_id') ? undefined : json['salesforce_order_id'],
        'salesforceOpportunityCode': !(0, runtime_1.exists)(json, 'salesforce_opportunity_code') ? undefined : json['salesforce_opportunity_code'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, DealType_1.DealTypeFromJSON)(json['type']),
        'dsp': (0, DspProvider_1.DspProviderFromJSON)(json['dsp']),
        'dspPartner': !(0, runtime_1.exists)(json, 'dsp_partner') ? undefined : (0, DspPartner_1.DspPartnerFromJSON)(json['dsp_partner']),
        'adFormats': (json['ad_formats'].map(DealAdFormats_1.DealAdFormatsFromJSON)),
        'videoDeliveryFormats': !(0, runtime_1.exists)(json, 'video_delivery_formats') ? undefined : (new Set(json['video_delivery_formats'].map(VideoDeliveryFormat_1.VideoDeliveryFormatFromJSON))),
        'placements': (json['placements'].map(DealPlacements_1.DealPlacementsFromJSON)),
        'priceFloorMicroAmount': json['price_floor_micro_amount'],
        'budgetMicroAmount': !(0, runtime_1.exists)(json, 'budget_micro_amount') ? undefined : json['budget_micro_amount'],
        'currencyCode': json['currency_code'],
        'targets': (0, Targets_1.TargetsFromJSON)(json['targets']),
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'startTime': (new Date(json['start_time'])),
        'endTime': (new Date(json['end_time'])),
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'mediaDurationMs': !(0, runtime_1.exists)(json, 'media_duration_ms') ? undefined : json['media_duration_ms'],
    };
}
exports.CreateDealRequestFromJSONTyped = CreateDealRequestFromJSONTyped;
function CreateDealRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'seat_id': value.seatId,
        'salesforce_deal_id': value.salesforceDealId,
        'salesforce_line_item_id': value.salesforceLineItemId,
        'salesforce_order_id': value.salesforceOrderId,
        'salesforce_opportunity_code': value.salesforceOpportunityCode,
        'type': (0, DealType_1.DealTypeToJSON)(value.type),
        'dsp': (0, DspProvider_1.DspProviderToJSON)(value.dsp),
        'dsp_partner': (0, DspPartner_1.DspPartnerToJSON)(value.dspPartner),
        'ad_formats': (value.adFormats.map(DealAdFormats_1.DealAdFormatsToJSON)),
        'video_delivery_formats': value.videoDeliveryFormats === undefined ? undefined : (Array.from(value.videoDeliveryFormats).map(VideoDeliveryFormat_1.VideoDeliveryFormatToJSON)),
        'placements': (value.placements.map(DealPlacements_1.DealPlacementsToJSON)),
        'price_floor_micro_amount': value.priceFloorMicroAmount,
        'budget_micro_amount': value.budgetMicroAmount,
        'currency_code': value.currencyCode,
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'start_time': (value.startTime.toISOString()),
        'end_time': (value.endTime.toISOString()),
        'category': value.category,
        'description': value.description,
        'media_duration_ms': value.mediaDurationMs,
    };
}
exports.CreateDealRequestToJSON = CreateDealRequestToJSON;
